export default {
  VALIDATED: 'VALIDATED',
  INVALIDATED: 'INVALIDATED',
  NOT_RECOGNIZED: 'NOT_RECOGNIZED',
  ADDED: 'ADDED',
}
